import { format, isSameDay, isToday } from "date-fns";
function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const SmallWeekView = ({displayedWeek, selectedDay, setSelectedDay, weekViewEventObject, calendarDaysWithEvents}) => {

  const changeSelectedDay = (day, sel) => {
    const [year, month, date] = day.split('-').map(Number);
    const newDate = new Date(year, month - 1, date);
    setSelectedDay({date: newDate, events: calendarDaysWithEvents[day].events, availabilities: calendarDaysWithEvents[day].availabilities})
  }

    return (
        <div className="grid grid-cols-7 text-sm leading-6 z-50 ml-14 text-gray-500 sm:hidden">
          {displayedWeek.map((date, index) => (
            <button key={date} onClick={() => changeSelectedDay(format(new Date(date), 'yyyy-MM-dd'))} type="button" className="flex flex-col items-center cursor-pointer border-none bg-white pt-2 pb-3">
              {format(date, 'EEEEE')}
              <span className={classNames( 
                (!isToday(date) && isSameDay(selectedDay.date, date)) && 'text-indigo-600 border border-solid border-indigo-600 p-0 rounded-full',
                (isToday(date) && !isSameDay(selectedDay.date, date) ) && 'rounded-full text-indigo-600' ,"mt-1 flex h-8 w-8 items-center justify-center font-semibold",
                (isToday(date) && isSameDay(selectedDay.date, date)) && 'bg-indigo-600 rounded-full text-white border-none'
                )}>
                  {format(date, 'd')}
              </span>
            </button>
          ))}
        </div>
    )
}
export default SmallWeekView